import { getTeamLogo } from '../../../../static/logos/TeamLogos';
import './HeaderBannerContent.css';
export default function HeaderBannerContent({ match, isMatchFinished, clubInfo }) {
  return (
    <div className="match-page__header-banner">
      <div className="match-page__header-container">
          <div className="match-page__header-teams-container">
            <div className="match-page__header-team match-page__header-team-home">
              <img src={getTeamLogo(match.home_team)} alt={`${match.home_team} logo`} className="match-page__header-logo"/>
              <span>{match.home_team}</span>
            </div>
            {isMatchFinished ? (
              <div className="match-page__header-score">
                <div className="points-home">{match.home_score} </div> <div className="points-away">{match.away_score}</div>
              </div>
            ) : (
              <span className="match-page__header-vs"> vs </span>
            )}
            <div className="match-page__header-team match-page__header-team-away">
              <span>{match.away_team}</span>
              <img src={getTeamLogo(match.away_team)} alt={`${match.away_team} logo`} className="match-page__header-logo"/>
            </div>
          </div>
          <div className="match-page__datetime">
            {isMatchFinished ? (
              <p>BEENDET</p>
            ) : (
                <p>{match.game_time}</p>
            )}
                <span>{match.date} </span>
          </div>
          <div className="match-page__venue">
                <span>{clubInfo.find(club => club.clubee_name === match.home_team)?.details.city} - </span>
              <span>{clubInfo.find(club => club.clubee_name === match.home_team)?.details.venue_name}</span>
          </div>
        </div>
    </div>
  )
}
